import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export type NextStep = { title: string; text: string };

type Props = { steps: readonly NextStep[] };

/**
 * What happens after a request is sent, numbered.
 *
 * An `ol`, because the order is the content. The numerals are drawn from the
 * list's own counter rather than typed into the copy, so a step inserted later
 * cannot renumber wrongly.
 */
export function NextStepList({ steps }: Props) {
  return (
    <Stack component="ol" spacing={5} sx={{ listStyle: 'none', m: 0, p: 0, counterReset: 'step' }}>
      {steps.map((step) => (
        <Stack
          key={step.title}
          component="li"
          direction="row"
          spacing={4}
          sx={{ counterIncrement: 'step' }}
        >
          <Typography
            aria-hidden
            sx={{
              flexShrink: 0,
              width: 32,
              height: 32,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              fontSize: '0.875rem',
              fontWeight: 700,
              color: 'primary.main',
              bgcolor: 'rgba(var(--mui-palette-primary-mainChannel) / 0.1)',
              '&::before': { content: 'counter(step)' },
            }}
          />
          <Stack spacing={1}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              {step.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {step.text}
            </Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
